import axios from 'axios';

// The axios interceptor rewrites /api/lobby... to /api/{STATE}/lobby...
const getSearchData = async () => {
  const response = await axios.get(`/api/lobby`);
  return response.data;
};

const searchLobby = async (q, signal) => {
  const response = await axios.get(`/api/lobby/search`, { params: { q }, signal });
  return response.data;
};

const getLobbyistById = async (id) => {
  const response = await axios.get(`/api/lobby/lobbyist/${id}`);
  return response.data;
};

const getCompanyById = async (id) => {
  const response = await axios.get(`/api/lobby/company/${id}`);
  return response.data;
};

const lobbyistService = { getSearchData, searchLobby, getLobbyistById, getCompanyById };

export default lobbyistService;
